import { Option } from '@cmg/common';

import { ManagerRole } from '../../../graphql';

export enum JuniorRole {
  JUNIOR_ACTIVE_BOOKRUNNER = 'JUNIOR_ACTIVE_BOOKRUNNER',
}

export const juniorRoleLabels: { [juniorRole in JuniorRole]: string } = {
  [JuniorRole.JUNIOR_ACTIVE_BOOKRUNNER]: 'Junior Active Bookrunner',
};

export const managerRoleLabels: { [managerRole in ManagerRole]: string } = {
  [ManagerRole.ActiveBookrunner]: 'Active Bookrunner',
  [ManagerRole.Bookrunner]: 'Bookrunner',
  [ManagerRole.CoLead]: 'Co-Lead',
  [ManagerRole.CoManager]: 'Co-Manager',
  [ManagerRole.GlobalCoordinator]: 'Global Coordinator',
  [ManagerRole.SellingGroupMember]: 'Selling Group Member',
  [ManagerRole.Underwriter]: 'Underwriter',
  [ManagerRole.FacilitationAgent]: 'Facilitation Agent',
};

export const sellingGroupManagerRoles: ReadonlyArray<ManagerRole> = [
  ManagerRole.SellingGroupMember,
  ManagerRole.FacilitationAgent,
];

export const juniorRoleLabelsMappedToManagerRoles = {
  [ManagerRole.ActiveBookrunner]: juniorRoleLabels.JUNIOR_ACTIVE_BOOKRUNNER,
};

const allRoleLabels = { ...juniorRoleLabels, ...managerRoleLabels };

const orderedRoles: (ManagerRole | JuniorRole)[] = [
  ManagerRole.GlobalCoordinator,
  ManagerRole.ActiveBookrunner,
  JuniorRole.JUNIOR_ACTIVE_BOOKRUNNER,
  ManagerRole.Bookrunner,
  ManagerRole.CoLead,
  ManagerRole.CoManager,
  ManagerRole.Underwriter,
  ManagerRole.SellingGroupMember,
  ManagerRole.FacilitationAgent,
];

/**
 * List of junior and manager role options, ordered by seniority.
 */
export const managerRoleOptions = orderedRoles.map<Option<ManagerRole & JuniorRole>>(type => ({
  label: allRoleLabels[type],
  value: type as ManagerRole & JuniorRole,
}));
